import { RootState } from "../../index";

export const selectWebhookList = (state: RootState) => state.webhookLibrary.webhookList;
export const selectWebhookPagination = (state: RootState) => state.webhookLibrary.pagination;
export const selectWebhookLoading = (state: RootState) => state.webhookLibrary.loading;
export const selectWebhookError = (state: RootState) => state.webhookLibrary.error;

export const getContactPropertiesOptions = (state: RootState) => state.webhookLibrary.contactOption;